import { render, staticRenderFns } from "./ReservationHistoryPopup.vue?vue&type=template&id=4d96f05e&scoped=true&"
import script from "./ReservationHistoryPopup.vue?vue&type=script&lang=js&"
export * from "./ReservationHistoryPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d96f05e",
  null
  
)

export default component.exports